module.exports = __webpack_public_path__ + "img/flow-01.82b8dc3c.svg";